@if(entityForm()){
<form [formGroup]="entityForm()">
    <div class="row mb-3">
        <div class="col-md-4">
            <div class="form-group">
                <label>Código</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="code">
                }@else{
                <div class="form-group mt-2">
                    <strong>{{entityForm().get('code')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-8">
            <div class="form-group">
                <label>Nombre</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="name">
                }@else{
                <div class="form-group mt-2">
                    <strong>{{entityForm().get('name')?.value}}</strong>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-6">
            <div class="form-group">
                <label>Campus</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="campus">
                }@else{
                <div class="form-group mt-2">
                    <strong>{{entityForm().get('campus')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Grupo</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="group">
                }@else{
                <div class="form-group mt-2">
                    <strong>{{entityForm().get('group')?.value}}</strong>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12">
            <div class="form-group">
                <label>Correo</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="email" class="form-control" formControlName="mail">
                }@else{
                <div class="form-group mt-2">
                    <strong>{{entityForm().get('mail')?.value || '—'}}</strong>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12">
            <div class="form-group">
                <label>Copia (CC)</label>
                @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <div class="tagify form-control"
                    [class.tagify--focus]="ccFocused"
                    (click)="ccInput.focus()">
                    @for (tag of ccTags(); track tag) {
                        <tag class="tagify__tag" [title]="tag">
                            <x class="tagify__tag__removeBtn tagify__tag_removeBtn"
                               role="button"
                               title="Quitar"
                               (click)="$event.stopPropagation(); removeCc(tag)"></x>
                            <div>
                                <span class="tagify__tag-text">{{ tag }}</span>
                            </div>
                        </tag>
                    }
                    <input #ccInput
                           class="tagify__input"
                           [(ngModel)]="ccDraft"
                           [ngModelOptions]="{standalone: true}"
                           placeholder="Agregar correo"
                           (keydown)="onCcKeydown($event)"
                           (blur)="commitCcDraft(); ccFocused = false"
                           (focus)="ccFocused = true">
                </div>
                <div class="form-text">Enter o coma para armar el tag. La X lo quita. El recuadro crece si hay varios.</div>
                }@else{
                <div class="form-group mt-2">
                    @if (ccTags().length) {
                        <div class="d-flex flex-wrap gap-1">
                            @for (tag of ccTags(); track tag) {
                                <span class="badge bg-light text-dark border">{{ tag }}</span>
                            }
                        </div>
                    } @else {
                        <strong>—</strong>
                    }
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row mb-1">
        <div class="col-12">
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch"
                       formControlName="isActive" id="entity-active">
                <label class="form-check-label" for="entity-active">
                    {{ entityForm().get('isActive')?.value ? 'Activa (se usa en FPV)' : 'Inactiva (queda al final del listado)' }}
                </label>
            </div>
        </div>
    </div>

    @if(mode() == formMode.VIEW){
    <div class="row">
        <div class="col-12 d-flex justify-content-end gap-2">
            @if (perm.canCurrent('canUpdate')) {
            <button class="btn btn-outline-primary btn-sm" (click)="editMode()">
                <i class="fas fa-edit"></i> Editar
            </button>
            }
            @if (perm.canCurrent('canUpdate')) {
            @if(entityForm().get('isActive')?.value){
            <button class="btn btn-outline-secondary btn-sm" (click)="desActivate(false,'Desactivar','desactivada')">
                <i class="fas fa-times"></i> Desactivar
            </button>
            }@else{
            <button class="btn btn-outline-success btn-sm" (click)="desActivate(true,'Activar','activada')">
                <i class="fas fa-check"></i> Activar
            </button>
            }
            }
        </div>
    </div>
    }
</form>
<ng-content></ng-content>
}